// extracted by mini-css-extract-plugin
module.exports = {"header":"kU3jU","title":"OnEZr","closeButton":"MBDvx","closeIcon":"GU5T7","content":"_4juss","padding_bottomIncrease":"k2aYx","theme_widget":"x4nI3"};